import { createMultiStyleConfigHelpers as r, defineStyle as o } from "@chakra-ui/react";
import { ThemeColorToken as e } from "../theme-tokens.js";
import { switchAnatomy as c } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const { definePartsStyle: t, defineMultiStyleConfig: i } = r(c.keys), h = o({
  backgroundColor: e.Surface,
  borderColor: e.OnSurfaceSubdued,
  borderStyle: "solid",
  borderWidth: "2px",
  _checked: {
    backgroundColor: e.Accent,
    borderColor: e.Accent
  },
  _disabled: {
    opacity: 0.48
  }
}), d = o({
  backgroundColor: e.OnSurfaceSubdued,
  _checked: {
    backgroundColor: e.OnAccent
  },
  _disabled: {
    opacity: 0.48
  }
}), n = {
  sm: t({
    thumb: {
      width: "12px",
      height: "12px",
      _checked: {
        transform: "translate(11px, -1px)",
        width: "14px",
        height: "14px"
      }
    },
    track: {
      width: "24px",
      height: "12px"
    },
    container: {
      width: "32px",
      height: "20px"
    }
  }),
  md: t({
    thumb: {
      width: "16px",
      height: "16px",
      _checked: {
        transform: "translate(15px, -1px)",
        width: "18px",
        height: "18px"
      }
    },
    track: {
      width: "32px",
      height: "16px"
    },
    container: {
      width: "40px",
      height: "24px"
    }
  })
}, a = t({
  track: h,
  thumb: d
}), x = i({
  baseStyle: a,
  sizes: n
});
export {
  x as switchConfig
};
